export default "__VITE_ASSET__Btpj2yRT__"